import React, { useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Link, useHistory } from "react-router-dom";
import loginImage from "../assets/images/mentors.png";
import { auth, googleProvider, db } from "../firebase";
import BrandingHeader from "../components/BrandingHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SignUp() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup, signupGoogle } = useAuth();
  const [loading, setLoading] = useState();
  const history = useHistory();

  const googleSignIn = async () => {
    await signupGoogle(googleProvider);
    auth.onAuthStateChanged((user) => {
      if (user) {
        db.collection("registered")
          .doc(user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              doc.data().user
                ? history.push("/member/dashboard")
                : history.push("/mentor/dashboard");
            } else {
              let isRegistered = {
                registered: "a",
              };
              sessionStorage.setItem(
                "isRegistered",
                JSON.stringify(isRegistered)
              );
              history.push("/getting-started");
            }
          });
      }
    });
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return toast.error("Passwords don't match");
    }

    try {
      setLoading(true);
      await signup(emailRef.current.value, passwordRef.current.value);
      let isRegistered = {
        registered: false,
      };
      sessionStorage.setItem("isRegistered", JSON.stringify(isRegistered));
      history.push("/getting-started");
    } catch (err) {
      toast.error(err.message);
    }
    setLoading(false);
  }

  const showPassword = () => {
    var x = document.getElementById("password");
    x.type === "password" ? (x.type = "text") : (x.type = "password");
  };

  const showConfirmPassword = () => {
    var x = document.getElementById("confirmPassword");
    x.type === "password" ? (x.type = "text") : (x.type = "password");
  };

  return (
    <div className="bg-white h-screen">
      <BrandingHeader />
      <div className="container mx-auto w-full flex flex-wrap  h-screen -mt-6">
        <div className="w-full md:w-1/2 flex flex-col pr-0 sm:pr-16">
          <div className="flex flex-col justify-center md:justify-start my-auto md:pt-auto px-8 md:px-16">
            <p className="mb-2 font-medium text-2xl"> Join Dev Colony today</p>
            <p className="text-sm text-gray-500 mb-4">
              Let's get you set up so you can verify your personal account and
              begin setting up your profile.
            </p>

            <div>
              <button
                type="button"
                onClick={googleSignIn}
                class="
                      w-full
                      items-center
                      block
                      px-10
                      py-2.5
                      text-base
                      font-medium
                      text-center text-blue-600
                      transition
                      duration-500
                      ease-in-out
                      transform
                      border-2 
                      rounded-lg
                      focus:outline-none
                      focus:ring-2
                      focus:ring-offset-2
                      focus:ring-gray-500
                    "
              >
                <div class="flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-6 h-6"
                    viewBox="0 0 48 48"
                  >
                    <defs>
                      <path
                        id="a"
                        d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
                      />
                    </defs>
                    <clipPath id="b">
                      <use href="#a" overflow="visible" />
                    </clipPath>
                    <path
                      clip-path="url(#b)"
                      fill="#FBBC05"
                      d="M0 37V11l17 13z"
                    />
                    <path
                      clip-path="url(#b)"
                      fill="#EA4335"
                      d="M0 11l17 13 7-6.1L48 14V0H0z"
                    />
                    <path
                      clip-path="url(#b)"
                      fill="#34A853"
                      d="M0 37l30-23 7.9 1L48 0v48H0z"
                    />
                    <path
                      clip-path="url(#b)"
                      fill="#4285F4"
                      d="M48 48L17 24l-4-3 35-10z"
                    />
                  </svg>
                  <span class="ml-4 text-gray-900"> Log in with Google</span>
                </div>
              </button>
            </div>
            <div class="relative my-4">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-300"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 bg-white text-neutral-600">
                  {" "}
                  Or continue with{" "}
                </span>
              </div>
            </div>
            <form className="flex flex-col mb-4">
              <label className="text-md mb-2">Email</label>
              <div class="relative text-gray-600">
                <div class="absolute left-3 top-0 mt-3 mr-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <input
                  type="email"
                  ref={emailRef}
                  id="email"
                  placeholder="your@email.com"
                  class="
                          block
                          w-full
                          px-5
                          py-2
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-50
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                  required
                />
              </div>

              <label className="text-md mt-6 mb-2">Password</label>
              <div class="relative text-gray-600">
                <div class="absolute left-3 top-0 mt-3 mr-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                    />
                  </svg>
                </div>
                <input
                  type="password"
                  id="password"
                  ref={passwordRef}
                  placeholder="at least 6 characters"
                  class="
                          block
                          w-full
                          px-5
                          py-2
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-50
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                />
                <div class="absolute right-0 top-0 mt-3 mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    onClick={showPassword}
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                </div>
              </div>

              <label className="text-md mt-6 mb-2">Confirm Password</label>
              <div class="relative text-gray-600">
                <div class="absolute left-3 top-0 mt-3 mr-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                    />
                  </svg>
                </div>
                <input
                  type="password"
                  id="confirmPassword"
                  ref={passwordConfirmRef}
                  placeholder="atleast 6 characters"
                  class="
                          block
                          w-full
                          px-5
                          py-2
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-50
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                />
                <div class="absolute right-0 top-0 mt-3 mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    onClick={showConfirmPassword}
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                </div>
              </div>
              <button
                type="submit"
                class="
                flex
                mt-4
                items-center
                justify-center
                w-full
                px-10
                py-2.5
                text-base
                font-medium
                text-center text-white
                transition
                duration-500
                ease-in-out
                transform
                bg-gradient-to-r from-blue-500 to-blue-900
                rounded-lg
                hover:bg-blue-700
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-500
              "
                disabled={loading}
                onClick={handleSubmit}
              >
                Sign up
              </button>
            </form>

            <div className="pt-1 sm:pt-6">
              <p>
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="underline font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-900"
                >
                  Log in
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="w-1/2 hidden md:flex items-center">
          <img class="object-cover object-center" alt="hero" src={loginImage} />
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default SignUp;
